/* eslint-disable no-use-before-define */
import { gql } from "@apollo/client";

export const ADD_ITEM_TO_ORDER = gql`
  mutation AddItemToOrder($productVariantId: ID!, $quantity: Int!) {
    addItemToOrder(productVariantId: $productVariantId, quantity: $quantity) {
      __typename

      ... on Order {
        id
      }

      ... on OrderModificationError {
        errorCode
        message
      }

      ... on OrderLimitError {
        errorCode
        message
        maxItems
      }

      ... on NegativeQuantityError {
        errorCode
        message
      }

      ... on InsufficientStockError {
        errorCode
        message
        quantityAvailable
      }
    }
  }
`;
